/*
 * @Author: your name
 * @Date: 2022-11-11 15:17:36
 * @LastEditTime: 2023-03-16 15:16:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/services/multipleInstances.ts
 */
import request from 'root/utils/request';

const basePath = '/api/ops-manager/v1/supos/runtime_env';

// 获取运行环境列表
export const getEnvListApi = async () => {
  return request.get(`${basePath}/multi_query`);
};

// 添加运行环境
export const addEnvApi = async (params: { envName: string; deployment: string }) => {
  return request.post(`${basePath}`, params);
};

// 运行环境删除
export const deleteEnvApi = async (params: { runtimeEnvId: string }) => {
  return request.delete(`${basePath}/delete`, { params: { ...params } });
};
